const actionTypes = {
  SET_RETAILER: "retailer/SET_RETAILER",
}

export default actionTypes
